// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2fw-x","balanceDisclaimer":"posDashboard_balanceDisclaimer__2d6o9"};